import React, { useContext } from 'react';
import CmsItemListSection from '../../shared/cmsPage/components/CmsItemListSection';
import CmsPage from '../../shared/cmsPage/components/CmsPage';
import ItemEditorModal from '../../shared/cmsPage/components/ItemEditorModal';
import useItemEditorModal from '../../shared/cmsPage/hooks/useItemEditorModal';
import ItemPublishStatus from '../../shared/itemTable/components/ItemPublishStatus';
import Timestamp from '../../shared/itemTable/components/Timestamp';
import useArray from '../../shared/util/hooks/useArray';
import menuApi from '../api/menuApi';
import { MenuConstants } from '../definitions';
import useMenuListActions from '../hooks/useMenuListActions';
import MenuEditorForm from './MenuEditorForm';
import MenuName from './MenuName';
import { CmsContext } from '../../context/definitions';
const MenuColumns = [
  {
    label: 'Name',
    valueField: 'name',
    sortable: true,
    initialSort: 'ASC',
    renderer: (menu) => <MenuName menu={menu} />,
  },
  {
    label: 'Display Label',
    valueField: 'label',
    sortable: true,
    align: 'center',
  },
  {
    label: 'Status',
    valueField: 'status',
    sortable: false,
    align: 'center',
    renderer: (menu) => <ItemPublishStatus status={menu.status} />,
  },
  {
    label: 'Last Modified',
    valueField: 'lastUpdated',
    sortable: true,
    align: 'center',
    renderer: (item, field) => <Timestamp date={item[field]} />,
  },
];

const MenuListPage = () => {
  const { selectedSubtenant } = useContext(CmsContext);
  const isDefaultSubtenant = selectedSubtenant.isDefault;
  const { defaultPageId, typeName, pageTitle } = MenuConstants;
  const { showItemEditorModal, editorModalProps } = useItemEditorModal(
    MenuConstants.typeName,
    'name',
    menuApi,
    MenuEditorForm
  );
  const { add, edit, remove, restore, publish, requestPending, migrateMenus } =
    useMenuListActions(showItemEditorModal);
  const toolbarActionArray = [isDefaultSubtenant ? add : undefined, migrateMenus].filter(Boolean);
  const toolbarActions = useArray(...toolbarActionArray);
  const itemActions = useArray(edit, publish, remove, restore);
  return (
    <CmsPage title={pageTitle} requestPending={requestPending}>
      <CmsItemListSection
        pageId={defaultPageId}
        className="nav-manager"
        typeName={typeName}
        toolbarActions={toolbarActions}
        itemActions={itemActions}
        columns={MenuColumns}
        itemApi={menuApi}
        showSearchBar={false}
      />
      <ItemEditorModal {...editorModalProps} />
    </CmsPage>
  );
};

export default MenuListPage;
